<div class="temp-number-text" *ngIf="isValidTempTnSet() || errorContext">
    {{textSegment1}}<b>{{tempNumber.rcfTarget}}</b>{{textSegment2}}
    <button type="button" class="btn btn-link learn-more-link" id="learnmorebutton" (click)="openLearnMore()"> {{ 'temporary_number.learn_more' | translate }}.</button>
</div>

